import Translations from "translations/types";

const REVERSE_SEARCH_DASHBOARD_PAGE_KEY = "reverse_search_dashboard" as const;

const REVERSE_SEARCH_DASHBOARD_STEPS = {
  SEARCH_TAB: "search_tab",
} as const;

export const REVERSE_SEARCH_DASHBOARD_PAGE = {
  doneLabel: (t: Translations) => t.tours.reverseSearch.doneButton,
  exitOnOverlayClick: false,
  key: REVERSE_SEARCH_DASHBOARD_PAGE_KEY,
  nextLabel: (t: Translations) => t.tours.reverseSearch.nextButton,
  prevLabel: (t: Translations) => t.tours.reverseSearch.backButton,
  steps: {
    [REVERSE_SEARCH_DASHBOARD_STEPS.SEARCH_TAB]: {
      intro: (t: Translations) => t.tours.reverseSearch.stepA.intro,
      key: REVERSE_SEARCH_DASHBOARD_STEPS.SEARCH_TAB,
      step: 1,
      title: (t: Translations) => t.tours.reverseSearch.stepA.title,
    },
  },
} as const;
